"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Float = void 0;

var _reactNative = require("react-native");

var _native = _interopRequireDefault(require("styled-components/native"));

var _props = require("@sloth-system/props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fullWidthProps(props) {
  if (props.fullWidth) {
    return "width: 100%;";
  }

  return;
}

let platformSpecificStyles = _reactNative.Platform.OS === "web" ? `
  position: fixed;
` : `
    position: absolute;
    
    `;
let Float = _native.default.View`
  ${platformSpecificStyles}
  bottom: 0;
  left: 0;
  ${_props.paddingProps}
  ${fullWidthProps}
`;
exports.Float = Float;